import React from "react";
import { useHistory } from "react-router-dom";
import BackButton from "../IconButton/BackButton";
import { EMPTY_STRING } from "../../../constants";
const SideImage = ({
  imageUrl,
  children,
  shouldShowCenter = false,
  showBackButton,
  onBackPressClick,
  isAllowModal,
  ...props
}) => {
  const history = useHistory();
  return (
    <div className="row h-100 position-relative">
      {!isAllowModal && (
        <div className="col-md-6 p-0">
          {imageUrl && (
            <img
              src={imageUrl}
              alt="imageUrl"
              className="auth-image ratio ratio-4x3 h-100 w-100"
            />
          )}
        </div>
      )}

      <div
        className={`${
          isAllowModal
            ? "col-12 d-flex justify-content-center align-items-center"
            : "col-md-6 col-12 row d-md-flex"
        } ${shouldShowCenter ? "account-selection" : EMPTY_STRING}`}
      >
        <div
          className={`d-flex justify-content-center align-items-center ${
            isAllowModal
              ? "col-12"
              : "offset-md-1 offset-xl-2 col-md-10 col-lg-7 col-12 d-md-block flex-column "
          }`}
        >
          {children}
        </div>
      </div>

      {showBackButton && (
        <BackButton
          onClick={() => history.goBack()}
          text={"go back"}
          className="login-back-btn"
        />
      )}
    </div>
  );
};

export default SideImage;
